import { Typography } from '@mui/material';
import React from 'react';
import ConfirmationModal from '../../ConfirmationModal';
import { EmployeeTimeOff, EmployeeTimeOffMode } from '../../../types/EmployeeTimeOff';
import { humanizeDate } from '../../../utility/dateUtils';

interface Props {
  employeeTimeOff: EmployeeTimeOff;
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function AvailabilityDeleteConfirmation({ employeeTimeOff, open, onCancel, onConfirm }: Props) {
  const type = employeeTimeOff.mode === EmployeeTimeOffMode.WEEKLY ? 'schedule' : 'time off request';

  return (
    <ConfirmationModal
      isOpen={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      text={
        <Typography>
          Are you sure you want to delete this {type}{' '}
          <strong>
            {humanizeDate(employeeTimeOff.start_date)} - {humanizeDate(employeeTimeOff.end_date)}
          </strong>
          ?
        </Typography>
      }
    />
  );
}
